import { useCallback, useState } from 'react';
import type { TestListItem } from '../../../types/test-types';

interface UseTestSelectionResult {
  selectedTests: Set<string>;
  toggleTest: (filename: string) => void;
  toggleSelectAll: () => void;
}

export function useTestSelection(tests: TestListItem[]): UseTestSelectionResult {
  const [selectedTests, setSelectedTests] = useState<Set<string>>(new Set());

  const toggleTest = useCallback((filename: string) => {
    setSelectedTests((prev) => {
      const next = new Set(prev);
      if (next.has(filename)) {
        next.delete(filename);
      } else {
        next.add(filename);
      }
      return next;
    });
  }, []);

  const toggleSelectAll = useCallback(() => {
    setSelectedTests((prev) => {
      if (prev.size === tests.length) {
        return new Set();
      }
      return new Set(tests.map((t) => t.filename));
    });
  }, [tests]);

  return { selectedTests, toggleTest, toggleSelectAll };
}
